'use strict';

const baseActions = require('../../../contact/shared/actions/baseActions');
const copyText = require('bunsen/helpers/copyText')().extend(Object.assign({},
    require('../../../../../json/copy/contact-dealer'),
    require('../../../../../json/copy/make-offer')
));

const MakeOfferActions = {
    renderModal(ac, payload, done) {
        const {props, linkLocation, modalId} = payload;
        const itemPk = props.item.get('id');
        ac.executeAction(baseActions.initialLoad, {
            sendToOmtOnSuccess: !!props.isMessageCenter,
            itemPk,
            copyText,
            linkLocation
        });
        ac.executeAction(MakeOfferActions.setChatEvents);
        ac.executeAction(baseActions.openModal, {modalId});
        done();
    },

    setChatEvents(actionContext) {
        actionContext.dispatch('contact:chat:setEvents', {
            chatAbandonEvent: 'abandonMakeOffer',
            chatSuccessEvent: ''
        });
    },

    trackPageLoadModal(ac, payload) {
        const {props, purchaseTracking} = payload;
        let action = `email make offer button - ${props.tracking.emailTmplName}`;

        if (props.referredFromAmp) {
            action = 'pdp make offer button-amppage';
        }

        purchaseTracking.trackOfferEvent({
            category: 'make offer click',
            action
        });
    }
};

module.exports = {MakeOfferActions};



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/actions/IABActions.es.js